import { render } from "./EditGroupPermission.vue?vue&type=template&id=181f317f"
import script from "./EditGroupPermission.vue?vue&type=script&lang=js"
export * from "./EditGroupPermission.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__